import { PublicClientApplication, Configuration } from "@azure/msal-browser";

const tenant = process.env.REACT_APP_AAD_TENANT_ID!;
const clientId = process.env.REACT_APP_AAD_CLIENT_ID!;
const redirectUri = process.env.REACT_APP_AAD_REDIRECT_URI || (window.location.origin + "/admin/login/callback");

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenant}`,
    redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: { logLevel: 2 },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "email",],
};